import { render, staticRenderFns } from "./FormAlt.vue?vue&type=template&id=4ca5977c&scoped=true&"
import script from "./FormAlt.vue?vue&type=script&lang=js&"
export * from "./FormAlt.vue?vue&type=script&lang=js&"
import style0 from "./FormAlt.vue?vue&type=style&index=0&id=4ca5977c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5977c",
  null
  
)

export default component.exports